import axios from 'axios';
import * as Constants from '../../constants';
import { AXIOS_DEFAULT_OPTIONS } from '../';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';

export const updateChangePassword = (payload, publicKey) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const { uuid } = payload
    const url = `${portal.hostname}/admin/v2/users/password/expiry/${uuid}`;
    dispatch({ type: Constants.UPDATE_CHANGE_PASSWORD_REQUEST, payload: true })

    const headers = {};
    if(publicKey) {
      headers['Public-Key'] = publicKey;
    }

    await axios.put(url, payload, { credentials: 'include', headers })
      .then(() =>
        dispatch({
          type: Constants.UPDATE_CHANGE_PASSWORD_SUCCESS,
          payload: Constants.SUCCESS,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.UPDATE_CHANGE_PASSWORD_ERROR,
          payload: error,
        }),
      );
  };

export const fetchChangePasswordTokenValid = (token) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/admin/passwordResetTokenValidate?token=${token}`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) =>
        dispatch({
          type: Constants.CHANGE_PASSWORD_TOKEN_VALID_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: Constants.CHANGE_PASSWORD_TOKEN_VALID_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };